// extracted by mini-css-extract-plugin
module.exports = {"container":"GOLRow_container__3VoFL"};